var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
		position: 'absolute',
		left: _vm.clientCoordinates.clientX,
		top: 0,
	})},[_c('p',[_vm._v(_vm._s(_vm.clientCoordinates.clientX))]),_c('p',[_vm._v(_vm._s(_vm.clientCoordinates.clientX))]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")]),_c('p',[_vm._v("line 1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }